module.exports = __webpack_public_path__ + "img/b_21.242a20e4.jpg";